export default "__VITE_ASSET__BNQD93p$__"